export default __webpack_public_path__ + "static/media/gallery-10.e0744176.jpg";